<template>
    <transition name='fade'>
        <div v-if='!accepted' class='bottombar'>
            <div class='bottombar__text'>
                <strong>A24 Auctions uses cookies.</strong> We use cookies to personalize content, to provide social media features, and to analyze our traffic. We also share information about your use of our site with our social media and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services. Please read our <a>Terms of Use</a> for more information.
            </div>
            <Button label='I Accept' @action='accept()' />
        </div>
    </transition>
</template>

<script>
import Button from '@/components/controls/Button';

export default {
    components: {
        Button
    },
    data: () => ({
        accepted: !!localStorage.getItem('GdprAccepted')
    }),
    methods: {
        accept () {
            localStorage.setItem('GdprAccepted', true);
            this.accepted = true;
        }
    }
};
</script>
